import React, { useContext } from 'react'
import IframeClientContext from './IframeClientContext'

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const withIframeClient = (WrappedComponent) => {
  function WithIframeClient(props) {
    const {
      error,
      connecting,
      connected,
      closing,
      closingType,
      closed,
      clientConfiguration,
      hostContext,
      actions,
    } = useContext(IframeClientContext)

    const clientProps = {
      clientError: error,
      clientConnecting: connecting,
      clientConnected: connected,
      clientClosing: closing,
      clientClosingType: closingType,
      clientClosed: closed,
      clientConfiguration,
      clientHostContext: hostContext,
      clientActions: actions
    }
    return (
      <WrappedComponent {...props} {...clientProps} />
    )
  }

  WithIframeClient.displayName = `WithIframeClient(${getDisplayName(WrappedComponent)})`;
  return WithIframeClient
}

export default withIframeClient
